import BandwidthChart from './BandwidthChart';

export default BandwidthChart;
